// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a782244","765":"95980f13"}[chunkId] + ".chunk.js";
};